/* eslint-disable consistent-return */
import { loaderService } from 'src/services/loaderService';
import { apileads } from '../enviroment/apileads';

const getEstablecimiento = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/establecimientos');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.log('Error get List ');
  }
};

const getEstablecimientoVictoryMas = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/establecimientos-victory-mas');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.log('Error get List ');
  }
};

const getEstablecimientoTvs = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/establecimientos-tvs');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.log('Error get List ');
  }
};



const getEstablecimientoActivo = async () => {
  loaderService.show();
  const response = await apileads.get('/v1/establecimientos/campana');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.log('Error get List ');
  }
};

const postEstablecimiento = async (params) => {
  loaderService.show();
  const response = await apileads.post('/v2/establecimientos', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Postear');
  }
};

const putEstablecimiento = async (params) => {
  loaderService.show();
  const response = await apileads.put('/v2/establecimientos', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Actualizar');
  }
};

const deleteEstablecimiento = async (id) => {
  loaderService.show();
  const response = await apileads.delete(`/v2/establecimientos?id=${id}`);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.erro(error, 'Error al Eliminar');
  }
};


const getEstablecimientosByMunicipio = async (params) => {
  loaderService.show();
  const response = await apileads.post('/v1/establecimientos/ciudades', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    console.error(error, 'Error al Postear');
  }
};


// Edita el score del establecimiento (score y score_actas, 0..1) por id.
const putEstablecimientoScore = async ({ id, score }) => {
  loaderService.show();
  try {
    const response = await apileads.put('/v1/establecimiento-score', {
      id: parseInt(id, 10),
      score: Number(score),
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error, 'Error al actualizar score');
  } finally {
    loaderService.hide();
  }
};


export {
  getEstablecimiento,getEstablecimientoVictoryMas,getEstablecimientoTvs, postEstablecimiento, putEstablecimiento, deleteEstablecimiento, getEstablecimientoActivo , getEstablecimientosByMunicipio, putEstablecimientoScore
};
